<template>
    <div>
        <Layout>
            <div class="row form__common--center">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-header d-flex" style="gap: 0.5rem">
                            <h3 class="mb-0 title--screen">フォーム検索</h3>
                            <div class="ml-auto">
                                <ButtonActiveFilter
                                    :active.sync="isActive"
                                    @sizeHeight="(height) => (heightSizeTable = height)"
                                    :smallCol="560"
                                    :largeCol="53.9"
                                />
                            </div>
                        </div>
                        <div v-if="isActive" class="card-body position-relative">
                            <div class="row justify-content-center">
                                <div class="col-sm-6 position-static">
                                    <form class="needs-validation" autocomplete="off">
                                        <div v-if="!checkShowFilter" class="row form-group">
                                            <div class="col-sm-12">
                                                <KeyWordTag :config="configKeyword" class="flex-fill" />
                                            </div>
                                        </div>
                                        <template v-else>
                                            <div class="form-group row">
                                                <label class="col-sm-3" for="validationCustom05">{{ $t('managerForm.list.nameCampaign') }}</label>
                                                <div class="col-sm-9">
                                                    <Multiselect
                                                        :id="`select-campaign-default`"
                                                        :value.sync="formSearch.campaign"
                                                        :options="listDataCampaign"
                                                        :config="configForm.campaign"
                                                    />
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label class="col-sm-3" for="validationCustom05">{{ $t('managerForm.list.nameForm') }}</label>
                                                <div class="col-sm-9">
                                                    <InputText
                                                        :model.sync="formSearch.name"
                                                        :config="{
                                                            error: false
                                                        }"
                                                    />
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label class="col-sm-3" for="validationCustom05">{{ $t('managerForm.list.status') }}</label>
                                                <div class="col-sm-9">
                                                    <div class="d-flex flex-wrap">
                                                        <div v-for="item in STATUS_FORM" :key="item.id + 'sss'">
                                                            <InputRadio
                                                                class="mr-3 mb-2"
                                                                :model.sync="formSearch.status"
                                                                :id="`raido-statusForm_${item.id}`"
                                                                :name="`raido-statusForm`"
                                                                :value="item.id"
                                                                :label="item.value"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label class="col-sm-3" for="validationCustom05">{{ $t('managerForm.list.startDateCP') }}</label>
                                                <div class="col-sm-9">
                                                    <div class="d-flex align-items-center mb-2">
                                                        <DateNormal :full_date.sync="formSearch.date_from.campaign_start_date"> </DateNormal>
                                                        から
                                                    </div>
                                                    <div class="d-flex align-items-center mb-2">
                                                        <DateNormal
                                                            :full_date.sync="formSearch.date_to.campaign_start_date"
                                                            :config="{
                                                                error: false
                                                            }"
                                                        >
                                                        </DateNormal>
                                                        まで
                                                    </div>
                                                    <small>※年、年月のみの入力でも検索可能です。</small>
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label class="col-sm-3" for="validationCustom05">{{ $t('managerForm.list.endDateCP') }}</label>
                                                <div class="col-sm-9">
                                                    <div class="d-flex align-items-center mb-2">
                                                        <DateNormal
                                                            :full_date.sync="formSearch.date_from.campaign_end_date"
                                                            :config="{
                                                                error: false
                                                            }"
                                                        >
                                                        </DateNormal>
                                                        から
                                                    </div>
                                                    <div class="d-flex align-items-center mb-2">
                                                        <DateNormal
                                                            :full_date.sync="formSearch.date_to.campaign_end_date"
                                                            :config="{
                                                                error: false
                                                            }"
                                                        >
                                                        </DateNormal>
                                                        まで
                                                    </div>
                                                    <small>※年、年月のみの入力でも検索可能です。</small>
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label class="col-sm-3" for="validationCustom05">{{
                                                    $t('managerForm.list.endDateSecretariat')
                                                }}</label>
                                                <div class="col-sm-9">
                                                    <div class="d-flex align-items-center mb-2">
                                                        <DateNormal
                                                            :full_date.sync="formSearch.date_from.secretariat_end_date"
                                                            :config="{
                                                                error: false
                                                            }"
                                                        >
                                                        </DateNormal>
                                                        から
                                                    </div>
                                                    <div class="d-flex align-items-center mb-2">
                                                        <DateNormal
                                                            :full_date.sync="formSearch.date_to.secretariat_end_date"
                                                            :config="{
                                                                error: false
                                                            }"
                                                        >
                                                        </DateNormal>
                                                        まで
                                                    </div>
                                                    <small>※年、年月のみの入力でも検索可能です。</small>
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label class="col-sm-3" for="validationCustom05">{{ $t('managerForm.list.client') }}</label>
                                                <div class="col-sm-9">
                                                    <Multiselect
                                                        :id="`select-client-default`"
                                                        :value.sync="formSearch.client"
                                                        :options="listDataClient"
                                                        :config="configForm.client"
                                                    />
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label class="col-sm-3" for="validationCustom05">削除案件</label>
                                                <div class="col-sm-9">
                                                    <div class="d-flex flex-wrap">
                                                        <InputCheckBox
                                                            class="mr-3 mb-2"
                                                            :model.sync="formSearch.only_trashed"
                                                            :id="`raido-only_trashed`"
                                                            :name="`raido-only_trashed`"
                                                            :value="formSearch.only_trashed"
                                                            label=""
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </template>

                                        <div class="text-center mt-4">
                                            <button type="button" @click="clear()" class="btn btn-common btn-outline-primary" style="width: 100px">
                                                <i class="ri-restart-line"></i>クリア
                                            </button>
                                            <button type="button" @click="search()" class="btn btn-common btn-primary ml-3" style="width: 100px">
                                                <i class="ri-search-line"></i>検索
                                            </button>
                                            <button type="button" @click="handleShowFilter" class="btn btn-common filter btn-outline-primary">
                                                <i class="ri-equalizer-line"></i>絞り込み条件を表示
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card mb-0">
                        <div class="card-header">
                            <h3 class="mb-0 title--screen">
                                フォーム検索結果 <span>件数 ({{ configPage.total }})</span>
                            </h3>
                        </div>
                        <div class="card-body">
                            <TableListComponent
                                :heightTable="heightSizeTable"
                                :config="configTable"
                                :dataList="listDataTable"
                                :isLoading="isLoading"
                                :configPage.sync="configPage"
                                :stickyAction="true"
                                @onChangePage="getList()"
                            >
                                <template #row="{ row }">
                                    <tr>
                                        <td class="text-left">
                                            {{ row?.code ?? '' }}
                                        </td>
                                        <td class="text-left">
                                            <div class="el-table__cell" v-b-tooltip.hover :title="row?.campaign?.name ?? ''">
                                                {{ row?.campaign?.name }}
                                            </div>
                                        </td>
                                        <td class="text-left">
                                            <div class="el-table__cell" v-b-tooltip.hover :title="row.name">
                                                {{ row?.name ?? '' }}
                                            </div>
                                        </td>
                                        <td class="text-left">
                                            <div class="el-table__cell">{{ PAGE_TYPE_FIXED.find((pty) => pty.id == row?.type)?.label || '' }}</div>
                                        </td>
                                        <td class="text-left" style="width: 150px">
                                            <div class="el-table__cell">
                                                <a v-if="row.status === STATUS_FORM_LIST.PUBLISHING" :href="getFormPublicUrl(row)" target="_blank">{{
                                                    getFormPublicUrl(row)
                                                }}</a>
                                                <span v-else>{{ getFormPublicUrl(row) }}</span>
                                            </div>
                                        </td>
                                        <td style="width: 120px" :style="`background-color:${onHandleBgr(row?.status)}`">
                                            <div class="el-table__cell">{{ handleViewStatus(row?.status) ?? '' }}</div>
                                        </td>
                                        <td style="width: 150px">
                                            <div class="el-table__cell">
                                                <template
                                                    v-if="row.is_publish_start_date_now === OPTION_PUBLIC_START_FORM[1].id && !row.publish_start_date"
                                                >
                                                    <span>{{ $t('managerForm.list.nothingDate') }}</span>
                                                </template>
                                                <span>
                                                    {{ formatDateCommon(row.publish_start_date, 'dateTimeJP') }}
                                                    <br clear="none" />
                                                    <template v-if="row.publish_has_no_end_date">
                                                        {{ OPTION_PUBLIC_END_FORM[0].name }}
                                                    </template>
                                                    <template v-else>
                                                        {{ formatDateCommon(row.publish_end_date, 'dateTimeJP') }}
                                                    </template>
                                                </span>
                                            </div>
                                        </td>
                                        <td class="sticky_action text-left p-2" style="min-width: 400px">
                                            <div v-if="!row.deleted_at" class="d-flex justify-content-between" style="min-width: 400px">
                                                <div
                                                    class="d-flex justify-content-between w-100"
                                                    v-if="![STATUS_FORM_LIST.RESERVING].includes(row.status)"
                                                >
                                                    <div class="">
                                                        <a
                                                            href="javascript:void(0)"
                                                            :class="`btn btn-common-sml btn-info mr-2 ${[STATUS_FORM_LIST.RESERVING].includes(row.status) ? 'disabled_cursor' : ''}`"
                                                            @click="handleGoTo('/manager-form/view', row)"
                                                            ><i class="ri-file-list-2-line"></i>{{ $t('btn.detail') }}</a
                                                        >
                                                        <a
                                                            v-if="checkPermission('form.edit')"
                                                            href="javascript:void(0)"
                                                            :class="`btn btn-common-sml btn-primary mr-2 ${[STATUS_FORM_LIST.RESERVING].includes(row.status) ? 'disabled_cursor' : ''}`"
                                                            @click="handleGoTo('/manager-form/edit', row)"
                                                            ><i class="ri-edit-box-line"></i>{{ $t('btn.edit') }}</a
                                                        >
                                                        <template v-if="!isTypePageC(row.type)">
                                                            <b-button
                                                                :id="`popover-button-${row.id}`"
                                                                :tabindex="row.id"
                                                                class="btn btn-only-icon-sml btn-outline-primary mr-2"
                                                                variant="outline-primary"
                                                                ><i class="ri-more-fill"></i
                                                            ></b-button>
                                                            <b-popover
                                                                :target="`popover-button-${row.id}`"
                                                                placement="topleft"
                                                                class="popover-more"
                                                                triggers="click blur"
                                                            >
                                                                <a
                                                                    v-if="checkPermission('form.analytics')"
                                                                    href="javascript:void(0)"
                                                                    :class="`${[STATUS_FORM_LIST.RESERVING].includes(row.status) ? 'disabled_cursor' : ''}`"
                                                                    class="button-advance"
                                                                    @click="handleGoTo('/manager-form/analytics', row)"
                                                                >
                                                                    <div class="icon">
                                                                        <i class="ri-line-chart-line"></i>
                                                                    </div>
                                                                    {{ $t('landingPage.settingBasic.analytics') }}
                                                                </a>
                                                                <a
                                                                    href="javascript:void(0)"
                                                                    :class="`${[STATUS_FORM_LIST.RESERVING].includes(row.status) ? 'disabled_cursor' : ''}`"
                                                                    class="button-advance mt-2"
                                                                    @click="handleGoTo('/manager-form/advanced', row)"
                                                                >
                                                                    <div class="icon">
                                                                        <i class="ri-mail-line"></i>
                                                                    </div>
                                                                    {{ $t('managerForm.settingAdvanced.btnAdvanced') }}
                                                                </a>
                                                            </b-popover>
                                                        </template>
                                                        <a
                                                            v-if="
                                                                [STATUS_FORM_LIST.PUBLISHING].includes(row.status) &&
                                                                !row.is_first_create &&
                                                                checkPermission('form.edit')
                                                            "
                                                            href="javascript:void(0)"
                                                            class="btn btn-only-icon-sml btn-outline-primary mr-2"
                                                            @click="handleOpenModalSettingDate(row)"
                                                        >
                                                            <i class="ri-calendar-line"></i>
                                                        </a>
                                                        <a
                                                            href="javascript:void(0)"
                                                            :class="`btn btn-only-icon-sml btn-outline-primary  ${[STATUS_FORM_LIST.RESERVING].includes(row.status) ? 'disabled_cursor' : ''}`"
                                                            @click="onHandleOpenPreview(row)"
                                                            ><i class="ri-eye-line"></i
                                                        ></a>
                                                        <a
                                                            v-if="
                                                                [STATUS_FORM_LIST.PUBLISHING].includes(row.status) &&
                                                                !row.is_first_create &&
                                                                checkPermission('form.edit')
                                                            "
                                                            v-b-tooltip.hover="
                                                                `${row.is_a_changed ? $t('managerForm.noteUpdateFormWeb') : $t('landingPage.list.goToPublicPage')}`
                                                            "
                                                            href="javascript:void(0)"
                                                            :class="`btn btn-only-icon-sml btn-outline-${row.is_a_changed ? 'danger' : 'warning'} ml-2`"
                                                            @click="onHandleTranformPage(row)"
                                                        >
                                                            <i class="ri-global-line"></i>
                                                        </a>
                                                    </div>
                                                    <a
                                                        v-if="
                                                            ![STATUS_FORM_LIST.PUBLISHING].includes(row.status) &&
                                                            !row.is_first_create &&
                                                            checkPermission('form.edit')
                                                        "
                                                        href="javascript:void(0)"
                                                        :class="`btn btn-common-sml btn-warning ${![STATUS_FORM_LIST.CREATED, STATUS_FORM_LIST.UNPUBLISHED].includes(row.status) ? 'action__record' : ''}`"
                                                        :disabled="[STATUS_FORM_LIST.CREATED, STATUS_FORM_LIST.UNPUBLISHED].includes(row.status)"
                                                        @click="handleOpenModalSettingDate(row)"
                                                        ><i class="ri-global-line"></i>{{ $t('managerForm.list.settingDatePublish') }}</a
                                                    >
                                                </div>
                                                <template v-if="![STATUS_FORM_LIST.CREATED, STATUS_FORM_LIST.UNPUBLISHED].includes(row.status)">
                                                    <div v-if="[STATUS_FORM_LIST.RESERVING].includes(row.status)" class="d-flex">
                                                        <template v-if="checkPermission('form.edit') || checkPermission('form.view')">
                                                            <a
                                                                href="javascript:void(0)"
                                                                :class="`btn btn-common-sml btn-info mr-2`"
                                                                @click="handleGoTo('/manager-form/view', row)"
                                                                ><i class="ri-file-list-2-line"></i>{{ $t('btn.detail') }}</a
                                                            >
                                                        </template>
                                                        <a
                                                            href="javascript:void(0)"
                                                            class="btn btn-only-icon-sml btn-outline-primary mr-2"
                                                            @click="onHandleOpenPreview(row)"
                                                            ><i class="ri-eye-line"></i
                                                        ></a>
                                                        <a
                                                            v-if="checkPermission('form.edit')"
                                                            href="javascript:void(0)"
                                                            class="btn btn-common-sml btn-secondary mr-2"
                                                            @click="handleCancelNowBooking(row)"
                                                            >{{ $t('managerForm.list.cancelDateNowBooking') }}</a
                                                        >
                                                    </div>
                                                    <a
                                                        v-if="[STATUS_FORM_LIST.PUBLISHING].includes(row.status) && checkPermission('form.edit')"
                                                        href="javascript:void(0)"
                                                        class="btn btn-common-sml btn-danger"
                                                        @click="handleCancelPublish(row)"
                                                        ><i class="ri-indeterminate-circle-line"></i>{{ $t('managerForm.list.cancelPublishForm') }}</a
                                                    >
                                                </template>
                                            </div>
                                            <div v-else>
                                                <a
                                                    v-if="checkPermission('form.delete')"
                                                    href="javascript:void(0)"
                                                    :class="`btn btn-common btn-common-delete btn-outline-danger ml-2`"
                                                    @click="handleDeletePermanently({ id: row.id })"
                                                    ><i class="ri-delete-bin-line"></i>削除</a
                                                >
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                            </TableListComponent>
                        </div>
                    </div>
                </div>
            </div>
            <ModalSettingDatePublish
                v-if="this.configModalSettingDatePublish.model"
                :currentRowSettingDate="currentRowSettingDate"
                :configModalSettingDatePublish="configModalSettingDatePublish"
                @update-get-list="getList()"
            />
            <ModalPreviewForm v-if="configModalPrvForm.model" :formData="dataPrvForm" :prvFormConfig="configModalPrvForm" />
        </Layout>
    </div>
</template>

<script>
import Layout from '@/views/layouts/main';
import appConfig from '@/app.config';
import Multiselect from '@/components/Multiselect/main.vue';
import DateNormal from '@/components/DateCustoms/DateNormal/main.vue';
import TableListComponent from '@/components/TableList/main.vue';
import KeyWordTag from '@/components/KeywordTag/main.vue';
import moment from 'moment';
import ButtonActiveFilter from '@/components/ButtonColFilter/main.vue';
import ModalSettingDatePublish from './components/modal-setting-date-publish/main.vue';
import ModalPreviewForm from '@/views/pages/phase2/manager-form/components/modal-preview-form/main.vue';

import { checkPermission, getInfoUserLocalStorage, onHandleShowConfirm } from '@/utils/handlers';
import { isRolePartner } from '@/views/pages/require/handlers.js';
import {
    configs,
    STATUS_FORM,
    initFormSearch,
    initSettingDate,
    configSettingDate,
    OPTION_PUBLIC_START_FORM,
    OPTION_PUBLIC_END_FORM,
    STATUS_FORM_LIST,
    PAGE_TYPE_FIXED,
    ID_PAGE_TYPE
} from './constants';
import { handleStatus, validateEndDate } from './handlers';
import { InputRadio, InputCheckBox, InputText } from '@/components/Input';
import { managerFormMethods, masterMethods } from '@/state/helpers';
import { validateAllField } from '@/utils/validate';
import { showMessage } from '@/utils/messages';
import { formatMergeDateAndTime, formatDateCommon } from '@/utils/format';

export default {
    name: 'ManagerFormList',
    page: {
        title: 'キャンペーン一覧',
        meta: [{ name: 'description', content: appConfig.description }]
    },
    components: {
        Layout,
        Multiselect,
        InputRadio,
        InputCheckBox,
        InputText,
        DateNormal,
        TableListComponent,
        KeyWordTag,
        ButtonActiveFilter,
        ModalSettingDatePublish,
        ModalPreviewForm
    },
    beforeRouteEnter(to, from, next) {
        if (!checkPermission('form.view')) {
            next({ name: 'errorPage' });
        }
        next();
    },
    data() {
        return {
            PAGE_TYPE_FIXED,
            ID_PAGE_TYPE,
            configForm: configs,
            configTable: configs.configTable,
            configPage: configs.configPage,
            configKeyword: configs.configKeyword,
            configModalSettingDatePublish: configs.configModalSettingDatePublish,
            configModalPrvForm: configs.configModalPrvForm,
            STATUS_FORM: STATUS_FORM,
            OPTION_PUBLIC_START_FORM: OPTION_PUBLIC_START_FORM,
            OPTION_PUBLIC_END_FORM: OPTION_PUBLIC_END_FORM,
            STATUS_FORM_LIST: STATUS_FORM_LIST,
            formSearch: initFormSearch(),
            formSettingDate: initSettingDate(),
            configSettingDate: configSettingDate(),
            listDataTable: [],
            listDataCampaign: [],
            listDataNameForm: [],
            listDataClient: [],
            isLoading: false,
            checkShowFilter: false,
            currentRowSettingDate: null,
            isActive: true,
            heightSizeTable: '',
            dataPrvForm: null,
            domainForm: process.env.VUE_APP_DOMAIN_FORM,
            listCustomDomains: []
        };
    },
    computed: {
        isTypePageC() {
            return (typeRow) => ID_PAGE_TYPE.C === typeRow;
        }
    },
    methods: {
        checkPermission,
        ...managerFormMethods,
        ...masterMethods,
        formatDateCommon,

        handleShowFilter() {
            this.checkShowFilter = !this.checkShowFilter;
        },

        handleGoTo(url, row) {
            this.$router.push({ path: url, query: { id: row.id } });
        },
        onHandleOpenPreview(row) {
            const alias = this.PAGE_TYPE_FIXED.find((pty) => pty.id == row.type)?.alias || '';
            if ([this.ID_PAGE_TYPE.I, this.ID_PAGE_TYPE.B].includes(row.type)) {
                this.dataPrvForm = {
                    id: row.id,
                    page_type: {
                        id: row.type,
                        alias: alias
                    }
                };
                this.configModalPrvForm.model = true;
            } else {
                window.open(`/manager-form/preview?id=${row.id}&type=${alias}`, '_blank');
            }
        },
        async handleDeletePermanently(payload) {
            const confirmDelete = await onHandleShowConfirm({
                title: 'フォームと応募者データを完全削除します。よろしいですか。',
                text: '',
                icon: 'warning',
                cancelButtonText: 'キャンセル'
            });
            if (confirmDelete) {
                try {
                    const response = await this.deletePermanently(payload);
                    if (response.code !== 200) return;
                    this.getList();
                } catch (error) {
                    console.log('error', error);
                }
            }
        },

        handleOpenModalSettingDate(row) {
            this.currentRowSettingDate = row;
            this.configModalSettingDatePublish.title = this.$t('managerForm.list.settingDatePublish');
            this.configModalSettingDatePublish.model = true;
        },

        handleCloseModalSettingDatePublish() {
            this.formSettingDate = initSettingDate();
            this.configSettingDate = configSettingDate();
            this.configModalSettingDatePublish.model = false;
        },

        async handleSaveSettingDatePublish() {
            let checkDatePublish = validateAllField(this.configSettingDate);
            let checkStarPublichWithEndPublic = validateEndDate(
                this.configSettingDate['configFieldPublicationStartDateTime'],
                this.configSettingDate['configFieldPublicationEndDateTime']
            );
            if (!checkDatePublish || !checkStarPublichWithEndPublic) return;
            const nowJapan = new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Tokyo' }));
            let payload = {
                id: this.configModalSettingDatePublish.id_form,
                ...this.formSettingDate,
                publish_start_date:
                    this.formSettingDate.is_publish_start_date_now === 1
                        ? moment(nowJapan).format('YYYY-MM-DD HH:mm')
                        : formatMergeDateAndTime(this.formSettingDate.publish_start_date, this.formSettingDate.publish_start_time),
                publish_end_date: formatMergeDateAndTime(this.formSettingDate.publish_end_date, this.formSettingDate.publish_end_time)
            };
            delete payload.publish_start_time;
            delete payload.publish_end_time;
            try {
                const dataRes = await this.settingPublishTime(payload);
                if (dataRes?.code !== 200) {
                    showMessage(dataRes.code, this.$bvToast, this.$t('system.error'));
                    return;
                }
                this.handleCloseModalSettingDatePublish();
                this.getList();
            } catch (error) {
                console.log('error', error);
            }
        },

        async handleCancelPublish(row) {
            const confirm = await onHandleShowConfirm({ text: `フォーム「(${row.id}) ${row.name}」の公開を停止します。本当によろしいですか。` });
            if (confirm) {
                try {
                    const dataRes = await this.stopPublishNow({ id: row.id });
                    if (dataRes?.code !== 200) {
                        showMessage(dataRes.code, this.$bvToast, this.$t('system.error'));
                        return;
                    }
                    this.getList();
                } catch (error) {
                    console.log('error', error);
                }
            }
        },

        async handleCancelNowBooking(row) {
            const confirm = await onHandleShowConfirm({ text: `フォーム「(${row.id}) ${row.name}」の公開予約を解除します。本当によろしいですか。` });
            if (confirm) {
                try {
                    const dataRes = await this.stopPublishNow({ id: row.id });
                    if (dataRes?.code !== 200) {
                        showMessage(dataRes.code, this.$bvToast, this.$t('system.error'));
                        return;
                    }
                    this.getList();
                } catch (error) {
                    console.log('error', error);
                }
            }
        },

        onHandleChangeIsPublishStartDateNow(value) {
            this.configSettingDate.configFieldPublicationStartDateTime.error = false;
            this.formSettingDate.publish_start_date = '';
            this.formSettingDate.publish_start_time = '';
            this.configSettingDate.configFieldPublicationStartDateTime.valueSync = '';
            if (value === OPTION_PUBLIC_START_FORM[0].id) {
                this.configSettingDate.configFieldPublicationStartDateTime.typesValidate =
                    this.configSettingDate.configFieldPublicationStartDateTime.typesValidate.filter((item) => item !== 'requiredDate');
            } else {
                this.configSettingDate.configFieldPublicationStartDateTime.typesValidate.push('requiredDate');
            }
        },

        onHandleChangeIsPublishEndDateNow(value) {
            this.configSettingDate.configFieldPublicationEndDateTime.error = false;
            this.formSettingDate.publish_end_date = '';
            this.formSettingDate.publish_end_time = '';
            this.configSettingDate.configFieldPublicationEndDateTime.valueSync = '';
            if (value === OPTION_PUBLIC_END_FORM[0].id) {
                this.configSettingDate.configFieldPublicationEndDateTime.typesValidate =
                    this.configSettingDate.configFieldPublicationEndDateTime.typesValidate.filter((item) => item !== 'requiredDate');
            } else {
                this.configSettingDate.configFieldPublicationEndDateTime.typesValidate.push('requiredDate');
            }
        },

        clear() {
            this.configKeyword.arrayTag = [];
            this.formSearch = initFormSearch();
            this.getList();
        },
        search() {
            this.getList();
        },

        handleViewStatus(status) {
            return handleStatus(status);
        },

        onHandleBgr(objb) {
            const foundStt = STATUS_FORM.find((item) => item.id === objb);
            return foundStt?.backgroundColor;
        },

        getQueryString() {
            let query = [`page=${this.configPage.page}`, `limit=${this.configPage.limit}`, `sorts[id]=desc`];
            let copyForm = Object.assign({}, this.formSearch);

            if (copyForm) {
                if (copyForm.campaign !== null) copyForm.campaign_id = copyForm.campaign?.id;
                if (copyForm.client !== null) copyForm.client_id = copyForm.client?.id;

                if (copyForm.date_from) {
                    for (const [key, value] of Object.entries(copyForm.date_from)) {
                        if (key && value) query.push(`from[${key}]=${value}`);
                    }
                }
                if (copyForm.date_to) {
                    for (const [key, value] of Object.entries(copyForm.date_to)) {
                        if (key && value) query.push(`to[${key}]=${value}`);
                    }
                }
                if (copyForm.only_trashed) {
                    query.push(`only_trashed=1`);
                }

                if (copyForm.has) {
                    for (const [key, value] of Object.entries(copyForm.has)) {
                        if (key && value) query.push(`has[${key}]=${value}`);
                    }
                }

                if (!this.checkShowFilter) {
                    if (this.configKeyword.arrayTag.length > 0) query.push(`q=${this.configKeyword.arrayTag.toString()}`);
                } else {
                    for (const [key, value] of Object.entries(copyForm)) {
                        if (key !== 'date_from' && key !== 'date_to' && key !== 'campaign' && key !== 'client' && key !== 'only_trashed') {
                            if (['campaign_id', 'client_id', 'status'].includes(key)) {
                                query.push(`filters[${key}]=${value}`);
                            } else {
                                if (key && value) query.push(`search[${key}]=${value}`);
                            }
                        }
                    }
                }
            }
            return query.join('&');
        },

        async getList() {
            let query = this.getQueryString();
            this.isLoading = true;
            try {
                const data = await this.getListManagerForm(query);
                this.listDataTable = data.data;
                this.configPage.total = data._metadata.total;
                this.configPage.limit = data._metadata.limit * 1;
                if (!this.listDataTable.length && this.configPage.page !== 1) {
                    this.configPage.page = 1;
                    this.getList();
                } else {
                    this.isLoading = false;
                }
            } catch (error) {
                console.log('error', error);
            }
        },

        async getMasterCampaign() {
            this.isLoading = true;
            try {
                let query = 'all/campaigns';
                if (isRolePartner()) {
                    query += `?has[partner]=${getInfoUserLocalStorage().partner_id}`;
                }
                const dataRes = await this.listMaster(query);
                this.listDataCampaign = dataRes;
            } catch (error) {
                console.log('error', error);
            } finally {
                this.isLoading = false;
            }
        },

        async getListMasterClient() {
            try {
                const dataRespone = await this.listMaster('all/clients');
                this.listDataClient = dataRespone;
            } catch (error) {
                console.log('error', error);
            }
        },

        async getListMasterForm() {
            try {
                let query = `page=1&limit=9999&sorts[id]=desc`;
                const data = await this.getListManagerForm(query);
                this.listDataNameForm = data.data;
            } catch (error) {
                console.log('error', error);
            }
        },

        getFormPublicUrl(row) {
            let domainStr = this.domainForm;
            if (row?.custom_domain?.domain) {
                domainStr = row.custom_domain.domain;
            } else if (row?.custom_domain_id && this.listCustomDomains.length) {
                const found = this.listCustomDomains.find((d) => d.id === row.custom_domain_id);
                if (found) domainStr = found.domain;
            }
            return `https://${domainStr}/form/${row.url_public}`;
        },

        getFormPublishedUrl(row) {
            let domainStr = this.domainForm;
            if (row?.is_a_changed && row?.published_domain) {
                domainStr = row.published_domain;
            } else if (row?.custom_domain?.domain) {
                domainStr = row.custom_domain.domain;
            } else if (row?.custom_domain_id && this.listCustomDomains.length) {
                const found = this.listCustomDomains.find((d) => d.id === row.custom_domain_id);
                if (found) domainStr = found.domain;
            }
            return `https://${domainStr}/form/${row.url_public}`;
        },

        onHandleTranformPage(row) {
            window.open(this.getFormPublishedUrl(row), '_blank');
        },

        async onGetListCustomDomain() {
            try {
                const response = await this.getListCustomDomain('limit=1000');
                if (response?.data) {
                    this.listCustomDomains = response.data;
                }
            } catch (error) {
                console.log('error', error);
            }
        }
    },

    mounted() {
        this.configPage.page = 1;
        this.getList();
        this.getMasterCampaign();
        this.getListMasterClient();
        this.getListMasterForm();
        this.onGetListCustomDomain();
    },

    destroyed() {
        this.configKeyword.arrayTag = [];
    }
};
</script>

<style lang="scss" scoped></style>
